/*=============================================
=            Table Row Styling            =
=============================================*/

@import './pk-table-row.variables';

:host {
  @apply flex;
}

:host(.pk-table--row) {
  @apply relative mb-[--row--spacing] w-full rounded-[--row--border-radius] bg-[color:--row--bg-color] text-[color:--row--color];

  font-family: var(--row--font-family);

  &.has-shadow {
    box-shadow: var(--row--box-shadow);
  }

  &.has-stroke {
    @apply border-[length:--row--border-width] border-solid border-[color:--row--border-color];
  }

  &.has-divider {
    @apply border-0 border-b-[length:--row--border-width] border-solid border-[color:--row--border-color];

    &:last-child {
      @apply border-b-0;
    }
  }

  &.is-focused,
  &.is-checked {
    &::before {
      @apply absolute left-0 top-[1px] h-[calc(100%_-_3px)] w-[3px] bg-interaction content-[''];
    }
  }

  &.first-cell-mobile-header {
    @apply max-sm:flex-wrap;

    &::slotted(pk-table-cell) {
      @apply max-sm:w-auto max-sm:shrink-0 max-sm:grow-0 max-sm:basis-[25%] #{!important};
    }

    &::slotted(pk-table-cell:first-of-type) {
      @apply max-sm:shrink-0 max-sm:grow-[1] max-sm:basis-full #{!important};
      @apply max-sm:border-0 max-sm:border-b-[1px] max-sm:border-solid max-sm:border-ui-02 max-sm:border-r-transparent;
    }
  }

  &.fixed-width {
    @apply w-[initial];
  }
}
